import React, { useState } from 'react';
import { Send, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Row, Toggle } from '../settingsPrimitives';
import { useExtensionStore, selectApiClientEnabled } from '../../extensions/store';
import { useCollectionsStore } from '../../store/collectionsStore';
import { clearAllRequestHistory } from '../../hooks/collections/useRequestHistory';
import { ExtensionCardTitle } from './InstalledExtensionCard';

/**
 * Settings → Extensions → the built-in "API Client" card (owner, 28.10.2026):
 * requests, collections, environments and history behind ONE switch, shown
 * like the other extension cards and, like the other built-ins, with no
 * Uninstall. The rule is extensions/apiClientSwitch.js; turning it off keeps
 * the data, and History stops recording while it is off. "Clear history" is
 * the one way to delete the saved history from here (with a confirm).
 */
export default function ApiClientExtensionCard() {
  const { t } = useTranslation();
  const on = useExtensionStore(selectApiClientEnabled);
  const setOn = useExtensionStore((s) => s.setApiClientEnabled);
  const historyCount = useCollectionsStore((s) => (s.history || []).length);
  const [confirming, setConfirming] = useState(false);

  return (
    <div className="settings-section api-client-ext-card" data-testid="api-client-extension-card" style={{ paddingTop: 0 }}>
      <Row
        label={<ExtensionCardTitle Icon={Send} text={`${t('settings.apiClientExt.name')} · ${t('settings.apiClientExt.builtIn')}`} />}
        desc={t('settings.apiClientExt.desc')}
      >
        <Toggle value={on} onChange={(v) => setOn(v)} label={t('settings.apiClientExt.name')} />
      </Row>
      <div className="settings-row-desc api-client-ext-note">
        {on ? t('settings.apiClientExt.noteOn') : t('settings.apiClientExt.noteOff')}
      </div>
      <Row
        label={t('settings.apiClientExt.historyLabel')}
        desc={t('settings.apiClientExt.historyCount', { count: historyCount })}
      >
        {confirming ? (
          <span className="api-client-ext-confirm">
            <button
              type="button"
              className="settings-action-btn settings-action-btn--danger"
              onClick={() => {
                clearAllRequestHistory();
                setConfirming(false);
              }}
            >
              {t('settings.apiClientExt.clearConfirm')}
            </button>
            <button type="button" className="settings-action-btn" onClick={() => setConfirming(false)}>
              {t('common.cancel', 'Cancel')}
            </button>
          </span>
        ) : (
          <button
            type="button"
            className="settings-action-btn settings-action-btn--danger"
            disabled={historyCount === 0}
            onClick={() => setConfirming(true)}
          >
            <Trash2 size={13} aria-hidden />
            {t('settings.apiClientExt.clearHistory')}
          </button>
        )}
      </Row>
    </div>
  );
}
